var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.70469 5.28973L1.71296 0.29385C1.61988 0.200688 1.50937 0.126788 1.38775 0.0763693C1.26613 0.0259505 1.13578 0 1.00414 0C0.738274 0 0.483301 0.105701 0.295309 0.29385C0.202225 0.387011 0.128386 0.49761 0.0780091 0.619332C0.0276322 0.741054 0.00170425 0.871514 0.00170425 1.00326C0.00170425 1.26935 0.107317 1.52453 0.295309 1.71268L4.5882 5.99915L0.295309 10.2856C0.201736 10.3785 0.127465 10.489 0.07678 10.6108C0.0260953 10.7325 0 10.8631 0 10.995C0 11.1269 0.0260953 11.2575 0.07678 11.3793C0.127465 11.501 0.201736 11.6116 0.295309 11.7044C0.388118 11.7981 0.498536 11.8724 0.620194 11.9232C0.741852 11.9739 0.872341 12 1.00414 12C1.13593 12 1.26642 11.9739 1.38808 11.9232C1.50973 11.8724 1.62015 11.7981 1.71296 11.7044L6.70469 6.70856C6.79826 6.61568 6.87254 6.50517 6.92322 6.38341C6.97391 6.26165 7 6.13105 7 5.99915C7 5.86724 6.97391 5.73665 6.92322 5.61489C6.87254 5.49313 6.79826 5.38262 6.70469 5.28973Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight1);
export default __webpack_public_path__ + "static/media/arrowRight1.f1ccd87ca758127f7d42f4bba69aa06b.svg";
export { ForwardRef as ReactComponent };